import PropTypes from 'prop-types';

import { QUESTION_TYPES } from '@api/instant_survey';
import { getQuestionTypeIcon, getQuestionTypeName } from '@helpers';
import { Card, Layout, Pill } from '@utilities';

import styles from './_index.module.scss';

const Questionnaire = ({ surveyQuestions }) => {
  return (
    <div className={styles['questionnaire']}>
      <h3>Questionnaire</h3>
      <Layout.Flex.Column as="ol" gap="small">
        {surveyQuestions?.map((question, index) => {
          const effectiveType = question?.turf ? QUESTION_TYPES.TURF.value : question?.type;
          const typeIcon = getQuestionTypeIcon(effectiveType);
          const typeName = getQuestionTypeName(effectiveType);
          return (
            <li key={question.id}>
              <Card as={Layout.Flex} className={styles['questionnaire-question']} elevation={1}>
                <div>
                  <strong>{index + 1}</strong>
                </div>
                <Layout.Flex.Column>
                  <Layout.Flex className={styles['questionnaire-question-body']} gap="small">
                    <Layout.Fill>{question.title}</Layout.Fill>
                    <div>
                      <Pill icon={typeIcon} isCompleted value={typeName} />
                    </div>
                  </Layout.Flex>
                </Layout.Flex.Column>
              </Card>
            </li>
          );
        })}
        {surveyQuestions?.length === 0 && <p>No questions are assigned to this survey.</p>}
      </Layout.Flex.Column>
    </div>
  );
};

Questionnaire.propTypes = {
  surveyQuestions: PropTypes.arrayOf(PropTypes.object),
};

export default Questionnaire;
